import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { DownloadsCardFragmentFragmentDoc } from '@packages/gql/generated/shopping/DownloadsCardFragmentFragmentDoc';
import { Card, CardContent, CardHeader } from '@packages/shared/src/ui/Card/Card';
import { useIntl } from 'react-intl';
import { DownloadItem } from '../DownloadItem/DownloadItem';
import { downloadsCardMessages } from './messages';

/* GraphQL */ `
  fragment DownloadsCardFragment on Product {
    downloads {
      ...DownloadItemFragment
    }
  }
`;
export type DownloadsCardProps = {
  data: FragmentType<typeof DownloadsCardFragmentFragmentDoc>;
};

/**
 * DownloadsCard component displays all available downloads
 * */
export const DownloadsCard = ({ data }: DownloadsCardProps) => {
  const { formatMessage } = useIntl();
  const { downloads } = getFragmentData(DownloadsCardFragmentFragmentDoc, data);

  if (!downloads.length) {
    return null;
  }

  return (
    <Card>
      <CardHeader hasDivider>{formatMessage(downloadsCardMessages.Header)}</CardHeader>
      <CardContent className="space-y-2 pb-2.5">
        {downloads.map((download, idx) => (
          <DownloadItem
            data={download}
            // eslint-disable-next-line react/no-array-index-key
            key={idx}
          />
        ))}
      </CardContent>
    </Card>
  );
};
